import MarkerWithLabel from '@google/markerwithlabel';

( function ( $, selector ) {

    // shortcut
    var google = window.google;

    $(document).ready( function(){
        var _that = $(selector);

        _that.each( function(){
            var _self = $(this);

            var _center = _self.data('mapcenter');

            if( google && ( _center.lat || _center.lng ) ) {

                var _point = { 'lat': _center.lat * 1 , 'lng': _center.lng * 1 };

                var _map = new google.maps.Map( this , {
                    center: _point,
                    zoom: 16,
                    disableDefaultUI: true,
                    // same styles than nvision_contact/contact_map
                    style: [
                        {
                            'featureType': 'administrative',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'visibility': 'off'
                                }
                            ]
                        },
                        {
                            'featureType': 'landscape',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'visibility': 'off'
                                }
                            ]
                        },
                        {
                            'featureType': 'poi',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'visibility': 'off'
                                }
                            ]
                        },
                        {
                            'featureType': 'road',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'visibility': 'simplified'
                                }
                            ]
                        },
                        {
                            'featureType': 'transit',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'visibility': 'off'
                                }
                            ]
                        }
                    ]
                });

                // create circle
                // @see https://developers.google.com/maps/documentation/javascript/examples/circle-simple
                // order determine z-index and elements collapse a little bit for create blurry effect

                // disc
                new google.maps.Circle({
                    strokeColor: null,
                    strokeOpacity: 0,
                    strokeWeight: 0,
                    fillColor: '#ff654d',
                    fillOpacity: 0.85,
                    map: _map,
                    center: _point,
                    radius: 65
                });
                // first ring
                new google.maps.Circle({
                    strokeColor: '#ff654d',
                    strokeOpacity: 0.5,
                    strokeWeight: 7,
                    fillColor: null,
                    fillOpacity: 0,
                    map: _map,
                    center: _point,
                    radius: 68.5
                });
                // second ring
                new google.maps.Circle({
                    strokeColor: '#ff654d',
                    strokeOpacity: 0.2,
                    strokeWeight: 11,
                    fillColor: null,
                    fillOpacity: 0,
                    map: _map,
                    center: _point,
                    radius: 77.5,
                });

                if( _self.data('maplabel') ) {
                    // add marker label
                    new MarkerWithLabel( {
                        position: _point,
                        cursor: 'default',
                        labelContent: _self.data('maplabel').replace( ' ' , '<br>' , 1 ),
                        // the "y" part seems to corrspond to a negative offset from center
                        // 24 is an approximation of one-line height
                        labelAnchor: new google.maps.Point( 65 , 24 * ( _self.data('maplabel').indexOf(' ') < 0 ? 0.5 : 1 ) ), // ( 65 - Item Height )  / 2
                        labelClass: 'property-full__section-map-label',
                        icon: {
                            size: new google.maps.Size( 130 , 130 ), // same than first circle
                            anchor: new google.maps.Point( 65 , 65 ), // anchor at center/center
                            fillOpacity: 0,
                            strokeOpacity: 0,
                            strokeWeight: 0,
                            path: 'M0 0L0 1 1 1 1 0Z' // square path
                        },
                        map: _map
                    } );
                }

            }

        } );

    } );

})( window.jQuery , '.property-full__section-map' );